<input
  #datePickerInput="ngModel"
  [ngModel]="internalInputDate()"
  matInput
  [matDatepicker]="picker"
  type="text"
  class="c-input c-clickable"
  [class.c-input--alpha]="size() === 'lg'"
  [class.c-input--gamma]="size() === 'md'"
  readonly="true"
  (click)="picker.open()"
  (ngModelChange)="change($event)"
  [matDatepickerFilter]="internalFilter()"
  required />
<input
  type="button"
  class="c-button c-button--calendar"
  [class.c-button--calendar-sm]="size() === 'md'"
  value="date"
  (click)="picker.open()" />
<mat-datepicker
  #picker
  [startAt]="internalInputDate()"
  panelClass="datepickerOne"></mat-datepicker>
<div
  *ngIf="datePickerInput.touched && datePickerInput.invalid"
  class="c-form-alert">
  {{ "datepicker.daterequirederror" | translate }}
</div>
